const status = (status) => {
  if (status) {
    return 'ATIVO'
  }

  return 'INATIVO'
}

export default status
